import ClearIcon from '@mui/icons-material/Clear';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getInfluencerListFordashboard } from '../../pages/dashboard/action';
import { updateDashboard } from '../../pages/dashboard/dashboardSlice';
import { setSearchdata } from '../../utils/common';
import { useState } from 'react';
import { FORM_SELECTFIELD_STYLES, trunCateString } from '../../utils/constant';

export default function BrandAutoCompleteDropdown({ handleChange, values, type,brandList }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let { filters ,limit} = useSelector((state) => state.dashboardSlice)
    const [fieldOptions, setFieldOptions] = useState(brandList)
    const handleEnterKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            const searchValue = event.target.value.trim();

            if (searchValue) {
                let data = { showLoading:true,list:[],filters: { platform: values?.platform || "Instagram", name: searchValue },limit:limit || 20,page:1,totalCount:0, };
                dispatch(updateDashboard(data));
                setSearchdata(JSON.stringify({ platform: values?.platform || "Instagram", name: searchValue }));
                dispatch(getInfluencerListFordashboard());
                if (type == "dashboard") {
                    navigate("/discover-influencers/listing");
                }
                return false;
            }
        }
    };
    return (
        <React.Fragment>
            <Autocomplete
                multiple={false}
                sx={{...FORM_SELECTFIELD_STYLES,
                    "& .css-xrrkm5-MuiPaper-root-MuiAutocomplete-paper":{
                        padding:'0px 0px 8px 0px !important'
                    }
                }}
                ListboxProps={{
                    sx: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        justifyContent: "flex-start",
                    },
                }}
                componentsProps={{
                    paper: {
                      sx: {
                          marginTop:'3px',boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)',
                        borderRadius:'12px',background:'white',border:'1px solid #EEE',padding:'0px 0px 0px 0px',
                        '& .MuiAutocomplete-listbox': {
                        gap:'0px !important'
                        },
                      },
                    },
                  }}
                value={values  || null}
                onChange={handleChange}
                limitTags={1}
                key={values}
                defaultValue={values || null }
                id="free-solo-dialog-demo"
                options={fieldOptions?.map((i)=>({name:i.brandName,id:i.id,image:i.brandImage}))}
                getOptionLabel={(option) => option.name}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                renderOption={(props, option, { index }) => {
                    return (
                        <>
                            <li {...props} style={{textTransform:'capitalize',fontSize:'14px',fontWeight:'500',color:'#565656',padding:'8px 16px',borderBottom:'1px solid #EEE',width: '100%', margin: "0", borderRadius: '0px', height: '40px',}}>{trunCateString(option?.name,30)}</li>
                           </>)
                }}
                clearIcon={<ClearIcon fontSize="small" onClick={() => {
                    setSearchdata(JSON.stringify({ platform: filters.platform }));
                    dispatch(updateDashboard({list:[], filters: { platform: filters.platform },page:1,limit:limit || 20,totalCount:0 }));
                }} />}
                freeSolo
                renderInput={(params) => <TextField
                     InputProps={{
                    ...params.InputProps,
                    sx: {
                      borderRadius: '12px',
                      backgroundColor: '#f5f5f5',
                      height: '10px',
                      padding:'0px !important',
                    },
                  }}
                  sx={{
                    '& .MuiInputBase-root': {
                      padding: '0px 10px',
                      lineHeight:'45px',
                    },
                    '& .MuiAutocomplete-input':{
                        padding:'0px 10px !important',
                    }
                  }}
                   {...params} label="" onKeyDown={handleEnterKeyPress} placeholder={"Enter Brand Name"} />}
            />

        </React.Fragment>
    );
}
